export const UNITS = {
    TENS_TWO_DIGIT: 2,
    HUNDREDS_THREE_DIGIT: 3,
    THOUSANDS_FOUR_DIGITS: 4
};

export const NUMBER_SYSTEM = {
    INDIAN: 'indian',
    INTERNATIONAL: 'international'
};

export const PERCENT = 100;
